<template>
  <v-card class="mt-4">
    <v-card-text class="black--text">
      <div class="d-flex flex-no-wrap justify-space-between">
        <b>{{ title }}</b>
      </div>

      <ChangesView :passport-id="passportId" :action-types="actionTypes" />
    </v-card-text>
  </v-card>
</template>

<script>
import ChangesView from './index.vue'

export default {
  components: { ChangesView },
  props: {
    title: {
      type: String,
      required: true,
    },
    passportId: {
      type: Number,
      required: true,
    },
    actionTypes: {
      type: Array,
      required: true,
    },
  },
}
</script>
